import React from 'react';

const RecommendationIcon = ({ className }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
        {/* Envelope body */}
        <rect x="1" y="7" width="16" height="12" rx="2" strokeWidth={2} />
        {/* Envelope flap */}
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M1 7l8 5.5L17 7" />
        {/* Star */}
        <polygon
            points="20,1.5 20.6,3.2 22.4,3.2 21,4.3 21.5,6 20,5 18.5,6 19,4.3 17.6,3.2 19.4,3.2"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeLinejoin="round"
        />
    </svg>
);

export default RecommendationIcon;
